import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const DataAudit = lazy(() => import("./DataAudit"));

const DATA_AUDIT_ROUTES: RouteObject[] = [
  {
    path: "/private/data-audit",
    element: React.createElement(DataAudit),
  },
  {
    path: "/private/data-audit/:parentModuleOptionTitle", 
    element: React.createElement(DataAudit),
  },
  {
    path: "/private/data-audit/:parentModuleOptionTitle/:childModuleOptionTitle?", 
    element: React.createElement(DataAudit),
  },
];

export default DATA_AUDIT_ROUTES;
